import { AclItemApiModel } from '../../AclItemApiModel';
import { QuizWorkflowStepApiModel } from './QuizWorkflowStepApiModel';
import { QuizQuestionBaseApiModel } from './QuizQuestionBaseApiModel';

export class QuizApiModel {
  public Id: number;
  public Name: string;
  public Description: string;
  public WhatIsSubject: AclItemApiModel[];
  public PassRate: number;
  public TimeLimit: number;
  public HideFromTrainers: boolean;
  public HideFromSupervisors: boolean;
  public HideAnswersFromTrainees: boolean;
  public IsActive: boolean;
  public HasInstanceNumber: boolean;
  public ProgramIds: number[];
  public WorkflowSteps: QuizWorkflowStepApiModel[];
  public Questions: QuizQuestionBaseApiModel[];

  public deserialize(data: Object): QuizApiModel {
    Object.assign(this, data);

    this.WhatIsSubject = this.WhatIsSubject?.map((x) => new AclItemApiModel().deserialize(x));
    this.WorkflowSteps = this.WorkflowSteps?.map((x) => new QuizWorkflowStepApiModel().deserialize(x));

    return this;
  }
}
